// src/components/Shared/ContactModal.jsx

import React from 'react';
import { Modal, Button } from 'antd';

export default function ModalContact({ visible, onCancel, onDownloadApp }) {
  return (
    <Modal
      title="Contáctanos"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="close" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
    >
      <div className="container-box">
        <p>
          <b>
            Si quieres registrarte como vendedor, descarga nuestra app móvil
            donde podrás darte de alta como vendedor.
          </b>
        </p>
        <p>Recuerda que nosotros solo conectamos a los clientes con vendedores.</p>
        <p>
          <b>Correo: mercanteomexico@gmail.com</b>
        </p>
        <p>
          <b>Teléfono de contacto: +52 0000 0000</b>
        </p>
        <Button type="primary" onClick={onDownloadApp}>
          Descargar App
        </Button>
      </div>
    </Modal>
  );
}
